import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { TuiSheetModule } from '@taiga-ui/addon-mobile';
import { TuiDialogContext, TuiDialogModule } from '@taiga-ui/core';
import { POLYMORPHEUS_CONTEXT } from '@tinkoff/ng-polymorpheus';
import { OrderQrcodeComponent } from '@us/web/orders/ui';
import { Order } from '@us/web/shared/data-access';

@Component({
    selector: 'us-order-qrcode-modal',
    templateUrl: './order-qrcode-modal.component.html',
    styleUrls: ['./order-qrcode-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IonicModule, TranslocoModule, OrderQrcodeComponent, TuiSheetModule, TuiDialogModule],
    standalone: true
})
export class OrderQrcodeModalComponent {
    private readonly context = inject(POLYMORPHEUS_CONTEXT) as TuiDialogContext<void, { order: Order }>;
    readonly order = this.context.data.order;

    handleClose(): void {
        this.context.completeWith();
    }
}
